var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9 10 61.46 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7317 12.1935C23.9685 12.1935 11.2519 24.7097 11.2519 39.9355C11.2519 55.1613 24.1009 67.6774 39.7317 67.6774C55.3625 67.6774 68.2115 55.1613 68.2115 39.9355C68.2115 24.7097 55.4949 12.1935 39.7317 12.1935ZM39.7317 70C22.7763 70 9 56.5806 9 39.9355C9 23.2903 22.7763 10 39.7317 10C56.6871 10 70.4634 23.4194 70.4634 39.9355C70.4634 56.4516 56.8196 70 39.7317 70Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1039 50.1774C44.1039 51.3343 45.3325 51.9127 47.7895 51.9127L46.9585 56.8293H28.0244L28.8555 51.9127C31.4932 51.9127 32.9747 51.2258 33.2277 49.8159L34.9621 39.6212C34.9621 38.392 33.7697 37.8136 31.3487 37.8136L32.1798 33.0054H47.0669L44.1039 50.1774ZM48.5122 25.6667C48.5122 26.4258 48.3677 27.1127 48.0786 27.7634C47.7895 28.4142 47.3921 28.9926 46.9223 29.4987C46.4165 30.0048 45.8383 30.4025 45.1879 30.6556C44.5375 30.9448 43.8148 31.0894 43.0922 31.0894C42.3695 31.0894 41.6468 30.9448 40.9964 30.6556C40.346 30.3664 39.7679 29.9687 39.262 29.4987C38.7561 28.9926 38.3587 28.4142 38.1057 27.7634C37.8166 27.1127 37.6721 26.3897 37.6721 25.6667C37.6721 24.9075 37.8166 24.2206 38.1057 23.5699C38.3948 22.9191 38.7923 22.3407 39.262 21.8346C39.7679 21.3285 40.346 20.9308 40.9964 20.6777C41.6468 20.4247 42.3334 20.2439 43.056 20.2439C43.7787 20.2439 44.5014 20.3885 45.1518 20.6777C45.8022 20.967 46.3803 21.3646 46.8862 21.8346C47.3921 22.3407 47.7895 22.9191 48.0425 23.5699C48.2954 24.2206 48.5122 24.9436 48.5122 25.6667Z",
    fill: "#F2B543"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_1851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4878,
    height: 36.5854,
    fill: "white",
    transform: "translate(28.0244 20.2439)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramInfo);
export default __webpack_public_path__ + "static/media/program-info.902157df48737f025249eb676973374a.svg";
export { ForwardRef as ReactComponent };